import { Cancel, CheckCircle, CheckCircleOutlined, MonetizationOn } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import googleImg from '../assets/googleImage.png';
import { chipStyle } from '../config/MaterialUIConstants';
import { CHIP_COLOR } from '../utility/Constant';
import {
    AuthorizedStatusIcon,
    InvoicedStatusIcon,
    OpenStatusIcon,
    ReapproveStatusIcon,
    SentStatusIcon,
    WorkOrderStatusIcon,
} from '../utility/Svg/DetailStatusIcons';

/*
 * Detail-page status chips and bars — the ONE place their label, icon, background and text colour are
 * defined, for the estimate, invoice and work order detail pages. Change a colour or icon here and every
 * detail page follows. Listing-page chips are separate and not driven from here.
 */

// const DraftIcon = () => (
//     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M10.833 16.666V18.3327H12.4997L17.4997 13.3327L15.833 11.666L10.833 16.666Z" stroke="#141B34" strokeWidth="1.5" />
//         <path
//             d="M9.99997 2.08268V7.49935H15.4166M15.8333 9.16602V7.49935L9.99997 1.66602H2.5V18.3327H7.5"
//             stroke="#141B34"
//             strokeWidth="1.5"
//             strokeLinecap="square"
//         />
//     </svg>
// );
const DraftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
            d="M19.0506 6.38689L15.6131 2.94939C15.5489 2.88567 15.4727 2.83526 15.3889 2.80104C15.3052 2.76683 15.2155 2.74949 15.125 2.75001H4.125C3.76033 2.75001 3.41059 2.89488 3.15273 3.15274C2.89487 3.4106 2.75 3.76034 2.75 4.12501V17.875C2.75 18.2397 2.89487 18.5894 3.15273 18.8473C3.41059 19.1051 3.76033 19.25 4.125 19.25H17.875C18.2397 19.25 18.5894 19.1051 18.8473 18.8473C19.1051 18.5894 19.25 18.2397 19.25 17.875V6.87501C19.2505 6.78453 19.2332 6.69484 19.199 6.61108C19.1648 6.52731 19.1143 6.45113 19.0506 6.38689ZM8.25 4.12501H13.75V6.87501H8.25V4.12501ZM13.75 17.875H8.25V12.375H13.75V17.875ZM15.125 17.875V12.375C15.125 12.0103 14.9801 11.6606 14.7223 11.4027C14.4644 11.1449 14.1147 11 13.75 11H8.25C7.88533 11 7.53559 11.1449 7.27773 11.4027C7.01987 11.6606 6.875 12.0103 6.875 12.375V17.875H4.125V4.12501H6.875V6.87501C6.875 7.23968 7.01987 7.58942 7.27773 7.84728C7.53559 8.10514 7.88533 8.25001 8.25 8.25001H13.75C14.1147 8.25001 14.4644 8.10514 14.7223 7.84728C14.9801 7.58942 15.125 7.23968 15.125 6.87501V4.40689L17.875 7.15689V17.875H15.125Z"
            fill="black"
        />
    </svg>
);

const BalanceRemainingIcon = () => (
    <div style={{ width: '22px', height: '22px' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_12968_20002)">
                <path
                    d="M22.9165 14.4102C21.736 13.9829 20.4254 14.0816 19.3207 14.681C19.3063 14.6882 14.9954 16.6364 14.9954 16.6364C14.6891 16.8658 14.3339 16.987 13.9681 16.987H11.2557C10.9188 16.987 10.6457 16.7142 10.6457 16.3776C10.6457 16.0411 10.9188 15.7683 11.2557 15.7683H13.9681C14.8159 15.7683 14.8345 14.0239 14.0041 13.9548L10.2236 13.9114C9.55656 13.904 8.88892 13.4752 8.18574 13.4591C7.47005 13.4428 6.79298 13.6253 6.19128 14.0155C5.35344 14.559 4.78144 15.4226 4.39805 16.3281L6.44339 21.4931H12.3245C12.8561 21.4929 13.3785 21.354 13.8402 21.0902L22.9671 15.869C23.2446 15.6337 23.459 15.3589 23.3648 14.937C23.3118 14.6997 23.1415 14.4918 22.9165 14.4102ZM0.61277 16.9609L3.40015 24L5.63754 22.7715L2.8501 15.7325L0.61277 16.9609ZM17.4094 0C14.4168 0 11.9908 2.45882 11.9908 5.4919C11.9908 8.52497 14.4168 10.9838 17.4094 10.9838C20.4019 10.9838 22.8279 8.52497 22.8279 5.4919C22.828 2.45882 20.402 0 17.4094 0ZM18.0251 8.23328V9.14369H16.7713V8.30733C16.2869 8.23533 15.8564 8.04256 15.4845 7.75036L15.9342 6.48928C16.2988 6.77579 16.8198 7.03759 17.2678 7.03759C17.6114 7.03759 17.8335 6.8799 17.8335 6.63579C17.8335 6.47713 17.7825 6.28703 17.1733 6.03877C16.4109 5.7379 15.6303 5.29656 15.6303 4.30805C15.6303 3.56174 16.0865 2.96215 16.8268 2.72574V1.84005H18.0729V2.64723C18.452 2.70641 18.8575 2.89128 19.1912 3.10651L18.7238 4.34769C18.3878 4.12364 17.9114 3.9062 17.5292 3.9062C17.1113 3.9062 17.0662 4.12036 17.0662 4.21241C17.0662 4.35656 17.1199 4.48097 17.8157 4.77046C18.4962 5.04959 19.2771 5.50749 19.2771 6.57995C19.2771 7.34615 18.7885 7.98697 18.0251 8.23328Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_12968_20002">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </div>
);

const GoogleIcon = () => (
    <img
        src={googleImg}
        alt="google"
        style={{ marginLeft: '-3px', width: '26px', height: '26px', paddingRight: '1px', aspectRatio: '1/1', objectFit: 'contain' }}
    />
);

const DEFAULT_TEXT = CHIP_COLOR.DEFAULT_COLOR;

/** Every detail-page status. `label` can be overridden per use (e.g. "Balance Owing: $10.00"). */
export const DETAIL_STATUS = {
    // Estimate + invoice
    DRAFT: { label: 'Draft', icon: <DraftIcon />, bg: CHIP_COLOR.DRAFT, color: DEFAULT_TEXT },
    FINALIZED: { label: 'Finalized', icon: <CheckCircleOutlined />, bg: CHIP_COLOR.FINALIZED, color: DEFAULT_TEXT },
    SENT: { label: 'Sent', icon: <SentStatusIcon />, bg: '#B0E8FC', color: DEFAULT_TEXT },
    // Same colour as a work order's Open chip (client, 2026-09-28).
    WORK_ORDER: { label: 'WO Created', icon: <WorkOrderStatusIcon />, bg: '#FFA429', color: DEFAULT_TEXT },
    // Invoice payment
    BALANCE_OWING: { label: 'Balance Owing', icon: <MonetizationOn />, bg: CHIP_COLOR.BALANCE_OWING, color: CHIP_COLOR.BALANCE_OWING_COLOR },
    FULLY_PAID: { label: 'Fully Paid', icon: <CheckCircle />, bg: CHIP_COLOR.FULLY_PAID, color: CHIP_COLOR.FULLY_PAID_COLOR },
    BALANCE_REMAINING: { label: 'Balance Remaining', icon: <BalanceRemainingIcon />, bg: CHIP_COLOR.BALANCE_REMAINING, color: DEFAULT_TEXT },
    GOOGLE_REVIEW_REQUESTED: {
        label: 'Requested',
        icon: <GoogleIcon />,
        bg: 'linear-gradient(81deg, #1A237E 36.53%, #4280EF 63.47%), #FFF',
        color: '#fff',
        labelSx: { letterSpacing: '0.15px', fontWeight: 500, lineHeight: '150%', marginLeft: '-5px' },
    },
    // Work order
    OPEN: { label: 'Open', icon: <OpenStatusIcon />, bg: '#FFA429', color: DEFAULT_TEXT },
    REAPPROVE: { label: 'Reapprove', icon: <ReapproveStatusIcon />, bg: '#9FE5FA', color: DEFAULT_TEXT },
    AUTHORIZED: { label: 'Authorized', icon: <AuthorizedStatusIcon />, bg: '#BCF3CC', color: DEFAULT_TEXT },
    INVOICED: { label: 'Invoiced', icon: <InvoicedStatusIcon />, bg: '#1B7130', color: '#FFFFFF' },
};

/** Full-width bars, used in place of a chip. */
export const DETAIL_STATUS_BAR = {
    AUTHORIZED: { label: 'Authorized', icon: <CheckCircleOutlined />, bg: '#EDF7ED', color: '#2E7D32' },
    CANCELLED: { label: 'Cancelled', icon: <Cancel />, bg: '#D32F2F', color: '#FFFFFF' },
};

/**
 * Status chip for detail pages.
 *
 * @param {object} status      one of DETAIL_STATUS
 * @param {string} [label]     overrides status.label
 * @param {string} [to]        route — makes the chip a link (e.g. the "Work Order" chip)
 * @param {Function} [onClick]
 */
export const DetailStatusChip = ({ status, label, to, onClick }) => {
    const navigate = useNavigate();
    if (!status) return null;
    const isClickable = Boolean(to || onClick);
    const { icon, bg, color, labelSx } = status;

    return (
        <Box
            component={isClickable ? 'button' : 'div'}
            type={isClickable ? 'button' : undefined}
            onClick={isClickable ? () => (onClick ? onClick() : navigate(to)) : undefined}
            sx={{
                ...chipStyle,
                background: bg,
                color,
                border: 'none',
                fontFamily: 'inherit',
                cursor: isClickable ? 'pointer' : 'default',
                '& .MuiSvgIcon-root': { fontSize: '22px', color },
                ...(isClickable && { '&:hover': { filter: 'brightness(0.95)' } }),
            }}
        >
            {icon}
            <Box component="span" sx={labelSx}>
                {label ?? status.label}
            </Box>
        </Box>
    );
};

/** Full-width status bar for detail pages (58px, 8px 16px padding, 4px radius). */
export const DetailStatusBar = ({ status, label }) => {
    if (!status) return null;
    const { icon, bg, color } = status;
    return (
        <Box
            sx={{
                width: '100%',
                height: '58px',
                padding: '8px 16px',
                borderRadius: '4px',
                background: bg,
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                boxSizing: 'border-box',
                marginTop: '16px',
                marginBottom: '8px',
                '& .MuiSvgIcon-root': { fontSize: '22px', color },
            }}
        >
            {icon}
            <Typography sx={{ color, fontSize: '16px', fontWeight: 500, lineHeight: '150%', letterSpacing: '0.15px' }}>{label ?? status.label}</Typography>
        </Box>
    );
};
